<template>
  <RoleFilter @filter="onFilter" @clear="onReset"/>
</template>
<script>
import { EventNames } from '@/plugins/enums/index.js'
import RoleFilter from '@/components/shared/Filters/Role-filter.vue';

export default {
  name: 'MeetingRole',

  components: {
    RoleFilter
  },

  methods:{
    onReset() {
      this.$eventBus.$emit(EventNames.ClearMeetingsFilter);
    },

    onFilter(selected){
      this.$eventBus.$emit(EventNames.FilterMeetingsByRole, selected.map(role => role.name));
    },
  },
}
</script>
